export default __webpack_public_path__ + "static/media/hotei24.3046700f.webp";